module.exports = __webpack_public_path__ + "3412d7631daf684810556e0ee9c7ca31.png";